import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Axios from "axios";

// CSS
import "../../assets/css/components/sidebar.css";

function Sidebar({ isSidebarOpen, setIsSidebarOpen }) {
  const [authData, setAuthData] = useState([]);

  const location = useLocation();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/authen`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        }
      );
      if (response.data.status === "OK") {
        setAuthData(response.data.decoded);
      } else {
        window.location.replace("/login");
      }
    } catch (error) {
      window.location.replace("/login");
    }
  };

  return (
    <>
      <div
        className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}
        data-background-color="dark"
      >
        <div className="sidebar-wrapper scrollbar scrollbar-inner">
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="btn btn-toggle-sidebar"
            style={{
              position: "relative",
              top: "1rem",
              left: isSidebarOpen ? "200px" : "10px",
              zIndex: 1000,
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "20px",
            }}
          >
            {isSidebarOpen ? "✖" : "☰"}
          </button>

          <div className="sidebar-logo">
            <div
              className="logo-header mt-4"
              data-background-color="dark"
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <button
                data-bs-toggle="modal"
                data-bs-target="#profileModal"
                className="logo"
                style={{
                  background: "none",
                  border: "none",
                  padding: "2.5rem",
                }}
              >
                <img
                  src={
                    window.localStorage.getItem("company") === "1"
                      ? "assets/img/logo_login.png"
                      : "assets/img/logo_ice.jpg"
                  }
                  alt="Logo"
                  className="navbar-brand"
                  width={100}
                  style={{
                    borderRadius: "30%",
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)",
                  }}
                />
              </button>
            </div>
          </div>

          <div className="sidebar-content">
            <ul className="nav nav-secondary">
              {/* User Information */}

              <li className="nav-item topbar-user dropdown hidden-caret">
                <center>
                  <button
                    style={{
                      marginLeft: "10px",
                      marginBottom: "10px",
                      textAlign: "center",
                      color: "#EF6C00",
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="btn dropdown-toggle profile-pic"
                    data-bs-toggle="modal"
                    data-bs-target="#profileModal"
                  >
                    <p className="text-white" style={{ margin: 0 }}>
                      <strong>{authData.Emp_Name || ""}</strong>
                    </p>
                    <i
                      className="fa fa-chevron-down ms-2 text-white"
                      style={{ fontSize: "10px" }}
                    ></i>
                  </button>
                  <p
                    className="text-white text-center"
                    style={{ marginTop: "-20px" }}
                  >
                    <strong>( {authData.Comp_ShortName || ""} )</strong>
                  </p>
                </center>
              </li>

              {/* Dashboard */}
              {/* <li
                className={`nav-item ${
                  location.pathname === "/" ? "active" : ""
                }`}
              >
                <a href="/" className="collapsed">
                  <i className="fas fa-home" style={{ color: "white" }} />
                  <p>Dashboard</p>
                </a>
              </li> */}

              {/* Reports */}
              {/* <li
                className={`nav-item ${
                  [
                    "/reports",
                    "/sales-report",
                    "/inventory-movement-report",
                    "/stock-balance-report",
                    "/loan-crate-report",
                    "/deposit-report",
                    "/overdue-loan-crate-report",
                    "/receivables-report",
                    "/payables-report",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a href="/reports" className="collapsed">
                  <i className="fas fa-file" style={{ color: "white" }} />
                  <p>รายงาน</p>
                </a>
              </li> */}

              {/* จัดซื้อสินค้า */}
              <li
                className={`nav-item ${
                  [
                    "/purchase",
                    // "/deposit-document",
                    // "/purchase-request",
                    // "/purchase-order",
                    // "/product-receipt",
                    "/payment-voucher",
                    "/purchase-list",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a href="/purchase" className="collapsed" aria-expanded="false">
                  <i
                    className="fas fa-shopping-cart"
                    style={{ color: "white" }}
                  />
                  <p>จัดซื้อสินค้า</p>
                  <span className="caret" />
                </a>
                <div className="collapse show" id="data">
                  <ul className="nav nav-collapse">
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/deposit-document"
                          ? "active"
                          : ""
                      }`}
                    >
                      <a href="/deposit-document">
                        <span className="sub-item">ใบมัดจำ</span>
                      </a>
                    </li> */}
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/purchase-request"
                          ? "active"
                          : ""
                      }`}
                    >
                      <a href="/purchase-request">
                        <span className="sub-item">ใบขอซื้อ</span>
                      </a>
                    </li> */}
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/purchase-order" ? "active" : ""
                      }`}
                    >
                      <a href="/purchase-order">
                        <span className="sub-item">ใบสั่งซื้อ</span>
                      </a>
                    </li> */}
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/product-receipt" ? "active" : ""
                      }`}
                    >
                      <a href="/product-receipt">
                        <span className="sub-item">ใบรับสินค้า</span>
                      </a>
                    </li> */}
                    <li
                      className={`nav-item ${
                        location.pathname === "/payment-voucher" ? "active" : ""
                      }`}
                    >
                      <a href="/payment-voucher">
                        <span className="sub-item">ใบสำคัญจ่าย</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              {/* คลังสินค้า */}
              <li
                className={`nav-item ${
                  [
                    "/warehouse",
                    "/warehouse-stock",
                    "/treasury-documents",
                    "/tbsetitem",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a
                  href="/warehouse"
                  className="collapsed"
                  aria-expanded="false"
                >
                  <i className="fas fa-building" style={{ color: "white" }} />
                  <p>คลังสินค้า</p>
                  <span className="caret" />
                </a>
                <div className="collapse show" id="data">
                  <ul className="nav nav-collapse">
                    <li
                      className={`nav-item ${
                        location.pathname === "/warehouse-stock" ? "active" : ""
                      }`}
                    >
                      <a href="/warehouse-stock">
                        <span className="sub-item">สต็อกคลังสินค้า</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/treasury-documents"
                          ? "active"
                          : ""
                      }`}
                    >
                      <a href="/treasury-documents">
                        <span className="sub-item">จัดการเอกสารคลัง</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/tbsetitem" ? "active" : ""
                      }`}
                    >
                      <a href="/tbsetitem">
                        <span className="sub-item">รายการสินค้า</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              {/* ใบยืม-ใบเบิก */}
              {/* <li
                className={`nav-item ${
                  [
                    "/borrow-withdrawal",
                    "/bill-of-lading",
                    "/icebox",
                    "/technical-equip-form",
                    "/office-equip-form",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a
                  href="/borrow-withdrawal"
                  className="collapsed"
                  aria-expanded="false"
                >
                  <i className="fas fa-retweet" style={{ color: "white" }} />
                  <p>ใบยืม-ใบเบิก</p>
                  <span className="caret" />
                </a>
                <div className="collapse show" id="data">
                  <ul className="nav nav-collapse">
                    <li
                      className={`nav-item ${
                        location.pathname === "/bill-of-lading" ? "active" : ""
                      }`}
                    >
                      <a href="/bill-of-lading">
                        <span className="sub-item">ใบเบิก Vansale</span>
                      </a>
                    </li>
                    {localStorage.getItem("company") === "2" && (
                      <>
                        <li
                          className={`nav-item ${
                            location.pathname === "/icebox" ? "active" : ""
                          }`}
                        >
                          <a href="/icebox">
                            <span className="sub-item">ใบยืมสินค้า</span>
                          </a>
                        </li>
                      </>
                    )}
                    <li
                      className={`nav-item ${
                        location.pathname === "/technical-equip-form"
                          ? "active"
                          : ""
                      }`}
                    >
                      <a href="/technical-equip-form">
                        <span className="sub-item">ใบเบิกอุปกรณ์ช่าง</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/office-equip-form"
                          ? "active"
                          : ""
                      }`}
                    >
                      <a href="/office-equip-form">
                        <span className="sub-item">ใบเบิกวัสดุใช้ภายใน</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li> */}

              {/* ขายสินค้า */}
              <li
                className={`nav-item ${
                  [
                    "/sellproducts",
                    // "/quotation",
                    "/order-product",
                    "/billofsale",
                    "/picking-list",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a
                  href="/sellproducts"
                  className="collapsed"
                  aria-expanded="false"
                >
                  <i className="fas fa-tags" style={{ color: "white" }} />
                  <p>ขายสินค้า</p>
                  <span className="caret" />
                </a>
                <div className="collapse show" id="data">
                  <ul className="nav nav-collapse">
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/quotation" ? "active" : ""
                      }`}
                    >
                      <a href="/quotation">
                        <span className="sub-item">ใบเสนอราคา (QT)</span>
                      </a>
                    </li> */}
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/order-product" ? "active" : ""
                      }`}
                    >
                      <a href="/order-product">
                        <span className="sub-item">ออเดอร์สินค้า (OD)</span>
                      </a>
                    </li> */}
                    <li
                      className={`nav-item ${
                        location.pathname === "/billofsale" ? "active" : ""
                      }`}
                    >
                      <a href="/billofsale">
                        <span className="sub-item">ใบขาย (SO)</span>
                      </a>
                    </li>
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/picking-list" ? "active" : ""
                      }`}
                    >
                      <a href="/picking-list">
                        <span className="sub-item">Picking List (PK)</span>
                      </a>
                    </li> */}
                  </ul>
                </div>
              </li>

              {/* งานบัญชี */}
              <li
                className={`nav-item ${
                  [
                    "/account",
                    "/payment-stock",
                    "/bill",
                    "/invoice",
                    "/tax",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a href="/account" className="collapsed" aria-expanded="false">
                  <i
                    className="fas fa-credit-card"
                    style={{ color: "white" }}
                  />
                  <p>งานบัญชี</p>
                  <span className="caret" />
                </a>
                <div className="collapse show" id="data">
                  <ul className="nav nav-collapse">
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/payment-stock" ? "active" : ""
                      }`}
                    >
                      <a href="/payment-stock">
                        <span className="sub-item">ตรวจสอบค้างจ่าย</span>
                      </a>
                    </li> */}
                    <li
                      className={`nav-item ${
                        location.pathname === "/bill" ? "active" : ""
                      }`}
                    >
                      <a href="/bill">
                        <span className="sub-item">ใบวางบิล (BI)</span>
                      </a>
                    </li>
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/invoice" ? "active" : ""
                      }`}
                    >
                      <a href="/invoice">
                        <span className="sub-item">ใบกำกับภาษี (INV)</span>
                      </a>
                    </li> */}
                    <li
                      className={`nav-item ${
                        location.pathname === "/tax" ? "active" : ""
                      }`}
                    >
                      <a href="/tax">
                        <span className="sub-item">หนังสือหัก ณ ที่จ่าย</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>

              {/* ข้อมูลตั้งต้น */}
              <li
                className={`nav-item ${
                  [
                    "/initialdata",
                    "/creditor",
                    "/debtor",
                    "/employee",
                    "/tbsetitem",
                    "/tb-set-unit",
                    "/tb-set-wh",
                  ].includes(location.pathname)
                    ? "active"
                    : ""
                } text-white`}
              >
                <a
                  href="/initialdata"
                  className="collapsed"
                  aria-expanded="false"
                >
                  <i className="fas fa-folder" style={{ color: "white" }} />
                  <p>ข้อมูลตั้งต้น</p>
                  <span className="caret" />
                </a>
                <div className="collapse show" id="data">
                  <ul className="nav nav-collapse">
                    <li
                      className={`nav-item ${
                        location.pathname === "/creditor" ? "active" : ""
                      }`}
                    >
                      <a href="/creditor">
                        <span className="sub-item">ข้อมูลเจ้าหนี้</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/APtype" ? "active" : ""
                      }`}
                    >
                      <a href="/APtype">
                        <span className="sub-item">ข้อมูลประเภทเจ้าหนี้</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/debtor" ? "active" : ""
                      }`}
                    >
                      <a href="/debtor">
                        <span className="sub-item">ข้อมูลลูกหนี้</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/ARtype" ? "active" : ""
                      }`}
                    >
                      <a href="/ARtype">
                        <span className="sub-item">ข้อมูลประเภทลูกหนี้</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/company" ? "active" : ""
                      }`}
                    >
                      <a href="/company">
                        <span className="sub-item">ข้อมูลบริษัท</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/dept" ? "active" : ""
                      }`}
                    >
                      <a href="/dept">
                        <span className="sub-item">ข้อมูลแผนก</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/position" ? "active" : ""
                      }`}
                    >
                      <a href="/position">
                        <span className="sub-item">ข้อมูลตำแหน่ง</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/employee" ? "active" : ""
                      }`}
                    >
                      <a href="/employee">
                        <span className="sub-item">ข้อมูลพนักงาน</span>
                      </a>
                    </li>
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/car" ? "active" : ""
                      }`}
                    >
                      <a href="/car">
                        <span className="sub-item">ข้อมูลรถ</span>
                      </a>
                    </li> */}
                    <li
                      className={`nav-item ${
                        location.pathname === "/transType" ? "active" : ""
                      }`}
                    >
                      <a href="/transType">
                        <span className="sub-item">ข้อมูลวิธีการขนส่ง</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/docType" ? "active" : ""
                      }`}
                    >
                      <a href="/docType">
                        <span className="sub-item">ข้อมูลประเภทเอกสาร</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/tbsetitem" ? "active" : ""
                      }`}
                    >
                      <a href="/tbsetitem">
                        <span className="sub-item">ข้อมูลสินค้า</span>
                      </a>
                    </li>
                    <li
                      className={`nav-item ${
                        location.pathname === "/brand" ? "active" : ""
                      }`}
                    >
                      <a href="/brand">
                        <span className="sub-item">ข้อมูลแบรนด์สินค้า</span>
                      </a>
                    </li>
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/tb-set-unit" ? "active" : ""
                      }`}
                    >
                      <a href="/tb-set-unit">
                        <span className="sub-item">ข้อมูลหน่วยสินค้า</span>
                      </a>
                    </li> */}
                    {/* <li
                      className={`nav-item ${
                        location.pathname === "/tb-set-wh" ? "active" : ""
                      }`}
                    >
                      <a href="/tb-set-wh">
                        <span className="sub-item">ข้อมูลคลังสินค้า</span>
                      </a>
                    </li> */}
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Modal */}
      <div
        className="modal fade"
        id="profileModal"
        tabIndex="-1"
        aria-labelledby="profileModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="profileModalLabel">
                User Profile
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="user-box">
                <div className="u-text">
                  <h4>{authData.Emp_Name}</h4>
                  <p className="text-muted">{authData.Dept_Name || ""}</p>
                  <p className="text-muted">{authData.PST_Name || ""}</p>
                  <p className="text-muted">{authData.Comp_Name_TH || ""}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                onClick={() => window.location.replace("/login")}
                className="btn btn-danger w-100"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
